<template>
  <div id="head-common">
    <div class="home-head">
      <div class="home-head-logo">
        <img src="./../../static/pic/logo.jpg" style="height: 100%; width: 100%" alt="">
      </div>
      <div class="home-head-motto"><p>雪域灰灰: 保持本心,坚持不懈</p></div>
      <div class="home-head-classify">
        <ul v-for="(item, index) in navList">
          <li @mouseover="aMoveOver(index, $event)"
              @mouseleave="aMoveLeave(index, $event)"
          >
            <router-link v-bind:to="{ name: item.routeName}">{{item.navName}}</router-link><!--<a href="#">{{item.routeName}}</a>-->
          </li>
          <!--<li @mouseover="aMoveOver($event)"
              @mouseleave="aMoveLeaveListenClick($event, simpleClickEventData.onClickOne)"
              @click="aClick($event)"><a href="#">学习</a></li>
          <li @mouseover="aMoveOver($event)"
              @mouseleave="aMoveLeaveListenClick($event, simpleClickEventData.onClickOne)"
              @click="aClick($event)"><a href="#">爱好</a></li>
          <li @mouseover="aMoveOver($event)"
              @mouseleave="aMoveLeaveListenClick($event, simpleClickEventData.onClickOne)"
              @click="aClick($event)"><a href="#">其他</a></li>-->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "HeadCommon",
      props: {
        indexProp: {
          type: Number,
          default: 0
        },
        onClickOneProps: {
          type: Boolean,
          default: false
        },
        navList: {
          type: Array,
          default: function () {
            return [
              {routeName: "userLogin", navName: "登录", onClickOne: false},
              {routeName: "UserInfo", navName: "其他", onClickOne: false},
              {routeName: "Study", navName: "学习", onClickOne: false},
              {routeName: "home", navName: "首页", onClickOne: false}
            ]
          }
        }
      },
      data: function () {
        return {
          simpleClickEventData:{
            paramCount:0,
            paramTitle:"雪域灰灰主页",
            aMoveActiveBg: "",
            aMoveActiveFont: "",
            onClickOne: false,
            onMoveOverOne: false,
            routeLiStyle: "",
            routeLiAStyle: ""
          },
          navList1: [
            {routeName: "home", navName: "首页", onClickOne: false},
            {routeName: "Study", navName: "学习", onClickOne: false},
            //{routeName: "home", navName: "爱好", onClickOne: false},
            {routeName: "UserInfo", navName: "其他", onClickOne: false},
            //{routeName: "Article", navName: "专属", onClickOne: false},
            {routeName: "userLogin", navName: "登录", onClickOne: false}
          ]
        }
      },
      mounted(){
        this.aClickInit();
      },
      methods: {
        aMoveOver: function (index, $event){
          let onClickOne = this.navList[index].onClickOne;
          if (false === onClickOne){
            let currentTarget = $event.currentTarget;
            currentTarget.className = "aMoveOver";
            //下一个元素 没有用到
            let next = currentTarget.nextElementSibling;
            //子元素
            let a = currentTarget.firstElementChild;
            if (a){
              let className = a.className;
              //a.style = "color: red";
              a.className = 'routerNameBefore';
              console.log(className, 'aMoveOver-className');
            }
            console.log(1, onClickOne, index, 'aMoveOver');
          }
        },
        aMoveLeave: function (index, $event) {
          let onClickOne = this.navList[index].onClickOne;
          //没有点击，才解锁移动触发
          if (onClickOne === false) {
            let currentTarget = $event.currentTarget;
            currentTarget.className = "routerStyleBefore";
            //子元素
            let a = currentTarget.firstElementChild;
            if (a){
              console.log(a.className, 'aMoveLeave');
              a.className = "routerNameBefore";
            }
          }
          console.log(2, onClickOne, index, 'aMoveLeave');
        },
        //不用点击，跳转初始化时自动应用
        aClick: function (index, $event) {
          console.log('3-1', index, this.navList[index].onClickOne, 'aClick');
          let currentTarget = $event.currentTarget;
          let ul = currentTarget.parentElement;
          let div = ul.parentElement;
          let i = 0;
          for (let childNode of div.childNodes) {
            let onClickOne = this.navList[i].onClickOne;
            console.log('3-', i, onClickOne, 'aClick');
            let childLi = childNode.firstElementChild;
            let routerLink = childLi.firstElementChild;
            if (index !== i){
              childLi.className = "routerStyleBefore";
              routerLink.className = "routerNameBefore";
              this.navList[i].onClickOne = false;
            } else {
              childLi.className = "routerStyleClick";
              routerLink.className = "routerNameClick";
              this.navList[i].onClickOne = true;
            }
            i++;
          }
          console.log('3-3', index, this.navList[index].onClickOne, 'aClick');
        },
        aClickInit: function () {
          let div = document.getElementsByClassName('home-head-classify');
          let divDom = div[0];
          let uls = divDom.childNodes;

          let i = 0;
          for (let childNode of uls) {
            let onClickOne = this.navList[i].onClickOne;
            console.log('3-', i, onClickOne, this.indexProp, 'aClickInit');
            let childLi = childNode.firstElementChild;
            let routerLink = childLi.firstElementChild;
            if (this.indexProp !== i) {
              childLi.className = "routerStyleBefore";
              routerLink.className = "routerNameBefore";
              this.navList[i].onClickOne = false;
            } else {
              childLi.className = "routerStyleClick";
              routerLink.className = "routerNameClick";
              this.navList[i].onClickOne = true;
            }
            i++;
          }
          console.log('3-', this.indexProp, this.navList[this.indexProp].onClickOne, 'aClickInit');
        }
      }
    }
</script>

<style scoped>
  div, img, ul, li, p, label, input{margin: 0 auto; padding: 0; border: 0;}
  #head-common .home-head{
    height: 160px;
    background: black;
  }
  #head-common .home-head .home-head-logo{
    display: inline-block;
    margin: 20px;
    height: 110px;
    width: 110px;
    float: left;
  }
  #head-common .home-head .home-head-logo img{
    display: inline-block;
    border-radius: 20px;
  }
  #head-common .home-head .home-head-motto{
    position: relative;
    left: 50px;
    float: left;
    display: inline-block;
    margin-top: 100px;
    padding: 5px;
    line-height: 20px;
  }
  #head-common .home-head .home-head-motto p {
    mask-image: linear-gradient(to right, red, orange, yellow, green, cyan, blue, purple);
    background-image: linear-gradient(to right, red, orange, yellow, green, yellow, orange, red, orange, yellow, green, yellow, orange, red);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: 200% 100%;
    animation: colorMove 5s infinite linear;/*infinite 播放次数无限 linear 从头到位速度是相同的*/
  }
  /*规定动画*/
  @keyframes colorMove {
    from {
      /*给图像应用色相旋转*/
      filter: hue-rotate(0);
    }
    to {
      filter: hue-rotate(4turn);
    }
  }
  #head-common .home-head .home-head-classify{
    display: inline-block;
    margin: 20px;
    width: 400px;
    float: right;
  }
  #head-common .home-head .home-head-classify li{
    display: table;
    float: right;
    margin: 20px 0;
    /*padding: 0 20px;*/
    min-width: 3em;
    border-width: 0 2px;
    border-style: ridge;
    border-color: #071ab4;
    text-align: center;
  }
  #head-common .home-head .home-head-classify li a{
    /*display: table-cell;
    vertical-align: middle;*/
    font-size: 0.8725em;
    font-weight: bold;
    line-height: 1.8em;
    text-transform: capitalize;/*文本中的每个单词以大写字母开头。*/
    text-decoration: none;
    font-style: initial;
  }
  a {
    color: white;
  }
  /*自定义模版class名称*/
  .routerStyleBefore {
    background: black;
  }
  .aMoveOver {
    background-color: blue;
  }
  .routerStyleClick {
    background-color: #1bc6ff;
  }
  .routerNameBefore {
    color: white;
  }
  .routerNameClick {
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeadCommon.vue